import { analyticsConfig, hasAnyAnalytics } from './config';
import { loadGa4, loadMetaPixel } from './loaders';

let initialized = false;

export function initAnalytics() {
  if (initialized || typeof window === 'undefined') return initialized;
  if (!hasAnyAnalytics()) {
    initialized = true;
    return initialized;
  }

  loadGa4(analyticsConfig.gaMeasurementId);
  loadMetaPixel(analyticsConfig.metaPixelId);
  initialized = true;
  return initialized;
}

export function __resetAnalyticsForTests() {
  initialized = false;
}

export { analyticsConfig, hasAnyAnalytics };
export { trackPageView } from './track';
